"use strict";

module.exports = function (column) {

  return this.query.hasOwnProperty(column) && this.opts.dateColumns.indexOf(column) == -1 && !this.opts.listColumns.hasOwnProperty(column);
};


// WEBPACK FOOTER //
// ./src/components/vuetable-2-kernel/compiled/methods/is-text-filter.js